import {Divider, Stack, Typography} from "@mui/material";
import {LoadingButton} from "@mui/lab";
import React from "react";
import {OperationVariables} from "@apollo/client/core";
import {useMutation, useQuery} from "@apollo/client";
import {GET_ACTIVE_DEPOSIT_LIMITS} from "../../../store/queries/GetActiveDepositLimits";
import {UseQuerySuspense} from "../../UseQuerySuspense/UseQuerySuspense";
import {DEACTIVATE_DEPOSIT_LIMIT} from "../../../store/mutations/DeactivateActiveDepositLimit";
import {useTranslation} from "react-i18next";
import {
    DeactivateActiveDepositLimitMutationMutation,
    DeactivateActiveDepositLimitMutationMutationVariables,
    GetActiveDepositLimitsQuery
} from "../../../gql/graphql";

export const Limit200EUR : React.FC<{takeAction: ()=>void, actionTakenState:OperationVariables}> = (props ) => {


    const {t,i18n} = useTranslation();

    const language = i18n.language;
    const depositLimits = useQuery<GetActiveDepositLimitsQuery>(GET_ACTIVE_DEPOSIT_LIMITS, {
        fetchPolicy: 'network-only'
    });
    const [deactivateLimit,deactivateLimitState] = useMutation<DeactivateActiveDepositLimitMutationMutation, DeactivateActiveDepositLimitMutationMutationVariables>(DEACTIVATE_DEPOSIT_LIMIT);
    
    return (<UseQuerySuspense data={depositLimits}>
        <Typography variant={'h5'} sx={{pr: 2}}>
            {language == "en" && (<>Your deposit limit has been changed</>)}
            {language == "fr" && (<>Votre limite de dépôt a été modifiée</>)}
            {language == "nl" && (<>Je stortingslimiet werd gewijzigd</>)}
        
    </Typography>

        <Typography variant={'body1'} sx={{pr: 2, mt: 2}}>
            {language == "en" && (<>Your deposit limit has been reduced to €200 since October 20th as a result of the new Royal Decree on Player Limits.</>)}
            {language == "fr" && (<>À partir du 20 octobre 2022, le nouvel arrêté royal sur les limites des joueurs rentre en vigueur. Toutes les limites de dépôts sur votre compte seront supprimées et une limite hebdomadaire de 200€ sera mise par défaut. </>)}
            {language == "nl" && (<>Je stortingslimiet werd teruggebracht naar €200 sinds 20 oktober ten gevolge van het nieuwe
                Koninklijk Besluit inzake spelerslimieten.</>)}
            
        </Typography>

        <Typography variant={'body1'} sx={{pr: 2}}>
            {language == "en" && (<>You can submit a request to change or cancel this limit. 
                Please note that any increase will only be processed after 72 hours.</>)}
            {language == "fr" && (<>Vous pouvez, si vous le souhaitez, demander à modifier ou annuler cette limite.
                Veuillez toutefois noter que toute augmentation ou annulation ne sera traitée que dans un délai de 72 heures.</>)}
            {language == "nl" && (<>Je kan een verzoek indienen tot het wijzigen of verwijderen van deze limiet. Houd er rekening
                mee dat elke verhoging pas na 72 uur wordt verwerkt.</>)}
        </Typography>

        <Divider sx={{mx: -4, mt: 2}}/>
        <Stack direction={'row'} spacing={2} sx={{mt: 2, pr: 0}} justifyContent={'flex-end'}>
            <LoadingButton loading={props.actionTakenState.loading} variant={'outlined'}
                           onClick={() => props.takeAction()}>

                {language == "en" && (<>keep €200 limit</>)}
                {language == "fr" && (<>garder la limite de 200€</>)}
                {language == "nl" && (<>behoud €200 limiet</>)}
            </LoadingButton>
            <LoadingButton loading={props.actionTakenState.loading} variant={'contained'}
                           onClick={() => {
                               props.takeAction();
                               (window as any).location = '/limits/change';
                               }}>
                {language == "en" && (<>change limit</>)}
                {language == "fr" && (<>modifier la limite</>)}
                {language == "nl" && (<>limiet aanpassen</>)}
                </LoadingButton>
            <LoadingButton loading={props.actionTakenState.loading || deactivateLimitState.loading} variant={'contained'}
                           onClick={() => {
                               deactivateLimit({
                                   variables: {
                                       limitId: parseInt(depositLimits.data?.limits?.nodes?.at(0)?.id as string)
                                   },
                                   onCompleted:()=>{
                                       props.takeAction();
                                   }
                               });
                               }}>

                {language == "en" && (<>cancel limit</>)}
                {language == "fr" && (<>annuler la limite</>)}
                {language == "nl" && (<>limiet annuleren</>)}
                </LoadingButton>
        </Stack>
        </UseQuerySuspense>)
}